import moment from 'moment';

const ShipmentWindowReadOnly = ({ data }) => {
  const { shipment, statement, serviceInfo, user } = data;
  return (
    <div>
      <div className="overflow-y-auto max-h-[70vh] p-4">
        <div className="flex flex-wrap justify-center">
          {/* Code/CV */}
          <div className="flex flex-col">
            <span className="text-blue-900">Code/CV</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.codeA || '---'}
            </div>
          </div>

          {/* First Mile Name*/}
          {data?.firstMileData1?.courier ? (
            <div className="flex flex-col">
              <span className="text-blue-900">First Mile Courier</span>
              <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
                {data?.firstMileData1?.courier || '---'}
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* First Mile Tracking */}
          {data?.firstMileData1?.courierTrackingCode ? (
            <div className="flex flex-col">
              <span className="text-blue-900">First Mile Tracking</span>
              <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
                {data?.firstMileData1?.courierTrackingCode || '---'}
              </div>
            </div>
          ) : (
            <></>
          )}
          {/* First Mile Price */}
          {data?.firstMileData1?.amounts ? (
            <div className="flex flex-col">
              <span className="text-blue-900">First Mile Price</span>
              <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
                {`${data?.firstMileData1?.amount} ${data?.firstMileData1?.currency}`}
              </div>
            </div>
          ) : (
            <></>
          )}
          {/* Shipment type */}
          <div className="flex flex-col">
            <span className="text-blue-900">Type</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.shipmentType || '---'}
            </div>
          </div>

          {/* Delivery method */}
          <div className="flex flex-col">
            <span className="text-blue-900">Delivery method</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sae || '---'}
            </div>
          </div>

          {/* Container */}
          <div className="flex flex-col">
            <span className="text-blue-900">Container</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.container || '---'}
            </div>
          </div>

          {/* Status */}
          <div className="flex flex-col">
            <span className="text-blue-900">Status</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.status || '---'}
            </div>
          </div>

          {/* Total price */}
          <div className="flex flex-col">
            <span className="text-blue-900">Total price</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.custOwn && shipment?.currencyCd
                ? `${shipment.custOwn} ${shipment.currencyCd}`
                : '---'}
            </div>
          </div>

          {/* Creation date */}
          <div className="flex flex-col">
            <span className="text-blue-900">Created at</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.firstDt
                ? moment(shipment.firstDt).format('MMM DD, YYYY hh:mmA')
                : '---'}
            </div>
          </div>

          {/* Last Edited */}
          <div className="flex flex-col">
            <span className="text-blue-900">Last Edited</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.editDt
                ? moment(shipment.editDt).format('MMM DD, YYYY hh:mmA')
                : '---'}
            </div>
          </div>

          {/* Statement */}
          <div className="flex flex-col">
            <span className="text-blue-900">Statement</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {statement?.name || '---'}
            </div>
          </div>

          {/* Shipping service */}
          <div className="flex flex-col">
            <span className="text-blue-900">Shipping service</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {serviceInfo?.serviceCode || '---'}
            </div>
          </div>

          {/* Value */}
          <div className="flex flex-col">
            <span className="text-blue-900">Value</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.value || '---'}
            </div>
          </div>

          {/* Insurance */}
          <div className="flex flex-col">
            <span className="text-blue-900">Insurance</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.insurance || '---'}
            </div>
          </div>

          {/* Weight */}
          <div className="flex flex-col">
            <span className="text-blue-900">{`Weight (${shipment?.weightCd})`}</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.weight || '---'}
            </div>
          </div>

          {/* Length */}
          <div className="flex flex-col">
            <span className="text-blue-900">Length</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.volL || '---'}
            </div>
          </div>

          {/* Width */}
          <div className="flex flex-col">
            <span className="text-blue-900">Width</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.volW || '---'}
            </div>
          </div>

          {/* Height */}
          <div className="flex flex-col">
            <span className="text-blue-900">Height</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.volH || '---'}
            </div>
          </div>

          <div className="w-full my-4 font-semibold">Sender</div>

          {/* Customer Code */}
          <div className="flex flex-col">
            <span className="text-blue-900">Customer Code</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.customerCd || '---'}
            </div>
          </div>

          {/* Sender's Last Name */}
          <div className="flex flex-col">
            <span className="text-blue-900">Last Name</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sLastName || '---'}
            </div>
          </div>

          {/* Sender's First Name */}
          <div className="flex flex-col">
            <span className="text-blue-900">First Name</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sFirstName || '---'}
            </div>
          </div>

          {/* Sender's Country */}
          <div className="flex flex-col">
            <span className="text-blue-900">Country</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sCountry || '---'}
            </div>
          </div>

          {/* Sender's State */}
          <div className="flex flex-col">
            <span className="text-blue-900">State</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sOblast || '---'}
            </div>
          </div>

          {/* Sender's City */}
          <div className="flex flex-col">
            <span className="text-blue-900">City</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sCity || '---'}
            </div>
          </div>

          {/* Sender's Address */}
          <div className="flex flex-col">
            <span className="text-blue-900">Address</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sStreet || '---'}
            </div>
          </div>

          {/* Sender's Apartment */}
          <div className="flex flex-col">
            <span className="text-blue-900">Apartment</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sApart || '---'}
            </div>
          </div>

          {/* Sender's House */}
          <div className="flex flex-col">
            <span className="text-blue-900">House</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sHouse || '---'}
            </div>
          </div>

          {/* Sender's ZIP */}
          <div className="flex flex-col">
            <span className="text-blue-900">ZIP</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sIndex || '---'}
            </div>
          </div>

          {/* Sender's Phone */}
          <div className="flex flex-col">
            <span className="text-blue-900">Phone</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sPhone || '---'}
            </div>
          </div>

          {/* Sender's Email */}
          <div className="flex flex-col">
            <span className="text-blue-900">Email</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.sEmail || '---'}
            </div>
          </div>

          {/* Sender's Birthday */}
          <div className="flex flex-col">
            <span className="text-blue-900">Birthday</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {user?.birthday
                ? moment(user?.birthday, 'YYYYMMDD').format('MMM DD, YYYY')
                : '---'}
            </div>
          </div>

          <div className="w-full my-4 font-semibold">Receiver</div>

          {/* Receiver's Last Name */}
          <div className="flex flex-col">
            <span className="text-blue-900">Last Name</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rLastName || '---'}
            </div>
          </div>

          {/* Receiver's First Name */}
          <div className="flex flex-col">
            <span className="text-blue-900">First Name</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rFirstName || '---'}
            </div>
          </div>

          {/* Receiver's Country */}
          <div className="flex flex-col">
            <span className="text-blue-900">Country</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rCountry || '---'}
            </div>
          </div>

          {/* Receiver's State */}
          <div className="flex flex-col">
            <span className="text-blue-900">State</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rOblast || '---'}
            </div>
          </div>

          {/* Receiver's City */}
          <div className="flex flex-col">
            <span className="text-blue-900">City</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rCity || '---'}
            </div>
          </div>

          {/* Receiver's Address */}
          <div className="flex flex-col">
            <span className="text-blue-900">Address</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rStreet || '---'}
            </div>
          </div>

          {/* Receiver's Apartment */}
          <div className="flex flex-col">
            <span className="text-blue-900">Apartment</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rApart || '---'}
            </div>
          </div>

          {/* Receiver's House */}
          <div className="flex flex-col">
            <span className="text-blue-900">House</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rHouse || '---'}
            </div>
          </div>

          {/* Receiver's ZIP */}
          <div className="flex flex-col">
            <span className="text-blue-900">ZIP</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rIndex || '---'}
            </div>
          </div>

          {/* Receiver's Phone */}
          <div className="flex flex-col">
            <span className="text-blue-900">Phone</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rPhone || '---'}
            </div>
          </div>

          {/* Receiver's Email */}
          <div className="flex flex-col">
            <span className="text-blue-900">Email</span>
            <div className="p-2 rounded w-[10vw] min-h-11 mx-5">
              {shipment?.rEmail || '---'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipmentWindowReadOnly;
